export default "__VITE_ASSET__DyHQpQih__"